import BaseCollectiveLogListItem from './BaseCollectiveLogListItem'
import { ICollectiveLogListItemProps } from './common'

const CollectiveLogDataOnGateDepositsChanged: React.FC<
  ICollectiveLogListItemProps<'CollectiveLogDataOnGateDepositsChanged'>
> = ({ bundledCollectiveLog, isLast }) => (
  <BaseCollectiveLogListItem
    bundle={bundledCollectiveLog}
    isLast={isLast}
    summaryActionText={`Setting "Allow Anyone to join?" was changed ${
      bundledCollectiveLog.logs.length === 1
        ? bundledCollectiveLog.logs[0].data.gateDeposits
          ? `to 'Yes'`
          : `to 'No'`
        : ''
    }`}
    hideSummaryActors
    detailsActionText={log => (
      <>
        {`Allow Anyone to join was changed to `}
        {log.data.gateDeposits ? `'Yes'` : `'No'`}
      </>
    )}
  />
)

export default CollectiveLogDataOnGateDepositsChanged
